module.exports = __webpack_public_path__ + "fonts/lato-regular-webfont.b52d9e50.woff";